import React from "react";
import { useNavigate } from "react-router-dom";

const StylesForFemale = ({ allStyles }) => {
  const navigate = useNavigate();

  // console.log('all styles to get Id ==>',allStyles);

  return (
    <div className="col-12 styles_for_female">
      <div>
        {allStyles?.map((item, key) => (
          <div key={key}>
            <img
              className="w-[350px] !h-[400px]"
              alt="img"
              onClick={() => {
                navigate("/tailoring/product", {
                  state: {
                    src: item.image_url,
                    id: 2,
                    stylename: item.name,
                    price: item.price,
                    uniqueId: item._id,
                    description: item.desc,
                    style_quantity: item.style_quantity,
                    category: item.category
                  },
                });

              }}
              src={item.image_url[0]}
            />
            <p className="styles_name">
              <span>{item.name}</span>
              <span>₦{item.price}.00</span>
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StylesForFemale;
